import script from "./Speeds.vue?vue&type=script&setup=true&lang=js"
export * from "./Speeds.vue?vue&type=script&setup=true&lang=js"

import "./Speeds.vue?vue&type=style&index=0&id=7829b8d5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7829b8d5"]])

export default __exports__